import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '@/services/jwt.service'
import i18nService from '@/services/i18n.service'
import qs from 'qs'
/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT || '/api'
    Vue.axios.defaults.withCredentials = true
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common.Authorization = `Token ${JwtService.getToken()}`
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      throw new Error(error)
    })
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {*}
   */
  get(resource, slug = '', params = {}) {
    // remove "slug" from params if someone passed it in
    const { slug: _ignore, ...rest } = params
    rest.locale = i18nService.getActiveLanguage()

    // build URL without accidental trailing slash
    const base = String(resource).replace(/\/+$/, '')
    const seg  = slug ? String(slug).replace(/^\/+|\/+$/g, '') : ''
    const url  = seg ? `${base}/${encodeURIComponent(seg)}` : base

    return Vue.axios.get(url, {
      params: rest,
      // keep if you need bracket array format: with[]=...&only[]=
      paramsSerializer: p => qs.stringify(p, { arrayFormat: 'brackets', encode: false }),
    })
    .catch((error) => {
      throw new Error(error)
    })
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch((error) => {
      throw new Error(error)
    })
  },
}

export default ApiService
